import type { PlanVisibilityScope, SoftwareSimple } from '../software.types';
import { CategorySimpleModel } from '@repositories/softwareCategoryRepository/models/CategorySimpleModel';

export class SoftwareSimpleModel {
  private readonly _dto: SoftwareSimple;
  private readonly _category: CategorySimpleModel;

  constructor(dto?: SoftwareSimple) {
    this._dto = dto || {} as SoftwareSimple;
    this._category = new CategorySimpleModel(dto?.category);
  }

  get originDTO(): SoftwareSimple {
    return this._dto;
  }

  get providerId(): string | null {
    return this._dto.providerId || null;
  }

  get id(): string {
    return this._dto.id || '';
  }

  get productCode(): string {
    return this._dto.productCode || '';
  }

  get name(): string {
    return this._dto.name || '';
  }

  get description(): string {
    return this._dto.description || '';
  }

  get url(): string {
    return this._dto.url || '';
  }

  get companyName(): string {
    return this._dto.companyName || '';
  }

  get iconUrl(): string {
    return this._dto.iconUrl || '';
  }

  get thumbnailUrl(): string {
    return this._dto.thumbnailUrl || '';
  }

  get categoryId(): string | undefined {
    return this.category?.id;
  }

  get category(): CategorySimpleModel {
    return this._category;
  }

  get categoryCount(): number {
    return this._dto.categoryCount || 0;
  }

  get isSubscribing(): boolean {
    return this._dto.isSubscribing ?? false;
  }

  public get planVisibilityScope(): PlanVisibilityScope {
    return this._dto.planVisibilityScope || 'ALL_USERS';
  }
}
